<template>
  <section class="mod-section mainColumn">
    <h2 class="mod-section_head mod-section_head-coffee">{{this.heading}}</h2>
    <div class="loading" v-if="loading">
      <div class="mod-loader"></div>
    </div>
    <template v-else>
      <div class="product-info">
        <div class="product-count" v-if="$refs.paginator">
          <p class="product-count_text_all">
            全<span class="product-count_text_all-number">{{this.products.length}}</span>件中
          </p>
          <p class="product-count_text_disp">
            <span class="product-count_text_disp-number">{{firstPage}}</span>-
            <span class="product-count_text_disp-number">{{lastPage}}</span>件
          </p>
        </div>
        <paginate-links
          for="items"
          :limit="2"
          :show-step-links="true"
          :step-links="{
            prev: '前へ',
            next: '次へ'
          }"
          :async="true">
        </paginate-links>
      </div>
      <transition name="fade" appear>
        <paginate
          class="product-list"
          ref="paginator"
          name="items"
          :list="products"
          :per="20">
          <li
            class="product-listItem"
            v-for="product in paginated('items')"
            :key="product.id">
            <a :href="product.link" class="product-listItem_link">
              <div class="product-listItem_img">
                <img v-if="product.product_meta.img_product"
                  :src="product.product_meta.img_product"
                  :alt="product.title.rendered" />
                <img v-else
                  src="/wp/wp-content/themes/mmc/assets/product/images/img_noimage.jpg"
                  alt="" />
              </div>
              <h3 class="product-listItem_title">{{product.title.rendered}}</h3>
              <p class="product-listItem_desc">{{textRender(product.product_meta.text_product_caption)}}</p>
              <p class="product-listItem_amount" v-if="product.product_meta.text_product_quantity">
              	内容量：{{product.product_meta.text_product_quantity}}
              </p>
            </a>
          </li>
        </paginate>
      </transition>
      <div class="product-info">
        <div class="product-count" v-if="$refs.paginator">
          <p class="product-count_text_all">
            全<span class="product-count_text_all-number">{{this.products.length}}</span>件中
          </p>
          <p class="product-count_text_disp">
            <span class="product-count_text_disp-number">{{firstPage}}</span>-
            <span class="product-count_text_disp-number">{{lastPage}}</span>件
          </p>
        </div>
        <paginate-links
          for="items"
          :limit="2"
          :show-step-links="true"
          :step-links="{
            prev: '前へ',
            next: '次へ'
          }"
          :async="true">
        </paginate-links>
      </div>
    </template>
  </section>
</template>

<script>
import axios from 'axios'
import 'promise-polyfill/src/polyfill'
export default {
  name: 'Route_Children',
  data () {
    return {
      cats: [],
      products: [],
      termId: null,
      loading: false,
      paginate: ['items'],
      heading: ''
    }
  },
  mounted: function () {
    this.createData()
    // fix for IE 11
    if (!!window.MSInputMethodContext && !!document.documentMode) {
	  window.addEventListener('hashchange', () => {
        var currentPath = window.location.hash.slice(1)
        if (this.$route.path !== currentPath) {
          this.$router.push(currentPath)
        }
      }, false)
    }
  },
  computed: {
    firstPage () {
      const page = this.paginate.items.page
      const first = (page * 20) + 1
      return `${first}`
    },
    lastPage () {
      const page = this.paginate.items.page
      const numOfItems = this.products.length
      const last = Math.min((page * 20) + 20, numOfItems)
      return `${last}`
    }
  },
  watch: {
    '$route' (to, from) {
      this.currentPage = 0
      if (to.params.id) {
        this.fetchData(to.params.id)
        switch (to.name) {
          case 'Home':
            this.heading = '家庭用商品一覧'
            break
          case 'Business':
            this.heading = '業務用商品一覧'
            break
          case 'Gift':
            this.heading = 'ギフト用商品一覧'
            break
        }
      } else {
        switch (to.path) {
          case '/home/':
            this.fetchData(15)
            this.heading = '家庭用商品一覧'
            break
          case '/business/':
            this.fetchData(16)
            this.heading = '業務用商品一覧'
            break
          case '/gift/':
            this.fetchData(17)
            this.heading = 'ギフト用商品一覧'
            break
          default:
            this.fetchData(15)
            this.heading = '家庭用商品一覧'
            break
        }
      }
    }
  },
  methods: {
    createData () {
      this.loading = true
      if (Object.keys(this.$route.params).length !== 0) {
        switch (this.$route.name) {
          case 'Home':
            this.termId = 15
            this.heading = '家庭用商品一覧'
            break
          case 'Business':
            this.termId = 16
            this.heading = '業務用商品一覧'
            break
          case 'Gift':
            this.termId = 17
            this.heading = 'ギフト用商品一覧'
            break
        }
        axios
          .get(`/wp-json/wp/v2/product_category?parent=` + this.termId + `&per_page=100&orderby=menu_order&order=asc`)
          .then(response => {
            this.cats = response.data
            for (let value of this.cats) {
              if (value.slug === this.$route.params.slug) {
                this.childId = value.id
                axios
                  .get(`/wp-json/wp/v2/products?product_category=` + this.childId + `&per_page=100&orderby=menu_order&order=asc`)
                  .then(response => {
                    this.products = response.data
                    this.loading = false
                  })
              }
            }
          })
      } else {
        switch (this.$route.path) {
          case '/home/':
            this.termId = 15
            this.heading = '家庭用商品一覧'
            break
          case '/business/':
            this.termId = 16
            this.heading = '業務用商品一覧'
            break
          case '/gift/':
            this.termId = 17
            this.heading = 'ギフト用商品一覧'
            break
          default:
            this.termId = 15
            this.heading = '家庭用商品一覧'
            break
        }
        axios
          .get(`/wp-json/wp/v2/products?product_category=` + this.termId + `&per_page=100&orderby=menu_order&order=asc`)
          .then(response => {
            this.products = response.data
            this.loading = false
          })
      }
    },
    fetchData (id) {
      this.paginate.items.page = 0
      this.loading = true
      axios
        .get(`/wp-json/wp/v2/products?product_category=` + id + `&per_page=100&orderby=menu_order&order=asc`)
        .then(response => {
          this.products = response.data
          this.loading = false
        })
    },
    textRender (text) {
      if (text.trim().length > 25) text = text.trim().substr(0, 25) + '...'
      return text
    }
  }
}
</script>

<style>
.v-enter-active, .v-leave-active {
  transition: opacity .5s
}
.v-enter, .v-leave-to {
  opacity: 0
}
.product-notfound {
  text-align: center;
  width: 100%;
  margin-top: 10px;
}
.product-heading_notfound {
  font-size: 1.6rem;
  font-weight: 700;
  letter-spacing: .075em;
}
.paginate-links {
  text-align: center;
  padding: 40px 0;
}
.paginate-links li {
  display: inline-block;
  width: 32px;
  height: 32px;
  line-height: 32px;
  font-weight: 700;
  color: #3a2c09;
  margin-right: 5px;
}
.paginate-links li a {
  display: block;
  width: 100%;
  height: 100%;
  color: #3a2c09;
  border-radius: 4px;
  cursor: pointer;
}
.paginate-links li a:hover,
.paginate-links li.active a,
.paginate-links li.left-arrow a,
.paginate-links li.right-arrow a {
  color: #3a2c09;
  background-color: #ebe9e6;
  opacity: 1;
}
.paginate-links li.left-arrow,
.paginate-links li.right-arrow {
  display: inline-block;
  width: 62px;
}
.paginate-links li.right-arrow {
  margin-right: 0;
}
.paginate-links li.left-arrow a::before,
.paginate-links li.right-arrow a::after {
  content: "";
  display: inline-block;
  width: 5px;
  height: 5px;
  border-top: 1px solid #41210f;
  border-right: 1px solid #41210f;
  margin-top: -1px;
  vertical-align: middle;
}
.paginate-links li.left-arrow a::before {
  margin-right: 8px;
  transform: rotate(-135deg);
}
.paginate-links li.right-arrow a::after {
  margin-left: 8px;
  transform: rotate(45deg);
}
.paginate-links li.disabled {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/RouteChildren.vue